module.exports = __webpack_public_path__ + "static/media/multiplex12.122b36c1.png";